import React, { useState } from 'react';

export interface ISingleLocationDonationItem {
	name: string;
	src: string;
}

export interface ISingleLocationDonationProps {
	accepted: ISingleLocationDonationItem[];
	denied: ISingleLocationDonationItem[];
}

const SingleLocationDonations: React.FC<ISingleLocationDonationProps> = ({
	accepted = [],
	denied = [],
}) => {
	const [showAccepted, setShowAccepted] = useState(true);

	return (
		<div className="location-single__donations">
			<div className="donation-nav">
				<div onClick={() => setShowAccepted(true)} className={showAccepted && 'active'}>Donations We Accept</div>
				<div onClick={() => setShowAccepted(false)} className={!showAccepted && 'active'}>What We Don't Accept</div>
			</div>
			<hr className="donation-hr" />
			<div className="donations">
				{showAccepted ? (
					accepted.map((item, index) => (
						<div key={index} className="donation-item">
							<img src={item.src} alt={item.name} />
							{item.name}
						</div>
					))
				) : (
					denied.map((item, index) => (
						<div key={index} className="donation-item">
							<img src={item.src} alt={item.name} />
							{item.name}
						</div>
					))
				)}
			</div>

		</div>
	);
};

export default SingleLocationDonations;
